/**
 * Rate limits for PISTE API (requests per second)
 */

export const PISTE_RATE_LIMITS = {
  default: 2,
  bulk: 20,
} as const;
